


import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Tabs, Tab } from "react-bootstrap"; 
import { baseURL } from "../../../../Apiservices/Api";
import Navbar from "../../../../Shared/ManagerNavbar/Navbar";
import { AuthContext } from "../../../../AuthContext/AuthContext";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import "./Email.css";

const M_MyEmailHistory = () => {
const { leadid } = useParams();
  const { userEmail } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { email } = location.state || {};
  const [emailHistory, setEmailHistory] = useState([]);
  const [text, setText] = useState("");
  const [subject, setSubject] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);
  const [collapsed, setCollapsed] = useState(false);
  const [receiverEmails, setReceiverEmails] = useState(email || "");
  const [ccEmails, setCcEmails] = useState("");
  const [bccEmails, setBccEmails] = useState("");
   const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [groupedEmailHistory, setGroupedEmailHistory] = useState([]);

  useEffect(() => {
    if (leadid) {
      fetchEmailHistory(leadid);
    }
  }, [leadid]);

  const fetchEmailHistory = async (leadid) => {
    try {
      if (!leadid) {
        console.error("Lead ID is required");
        return;
      }
  
      const response = await axios.get(`${baseURL}/api/email-history`, {
        params: { leadid }
      });
  
      const sortedEmails = response.data.sort((a, b) => 
        new Date(a.created_at) - new Date(b.created_at)
      );
  
      const groupedEmails = [];
      let currentGroup = null;
  
      sortedEmails.forEach((email) => {
        if (email.type === "sent") {
          if (currentGroup && 
              Math.abs(new Date(email.created_at) - new Date(currentGroup.created_at)) < 60000 &&
              email.subject === currentGroup.subject &&
              email.text === currentGroup.text) {
            
            currentGroup.recipients.push(email.receiver_email);
            if (new Date(email.created_at) < new Date(currentGroup.created_at)) {
              currentGroup.created_at = email.created_at;
            }
          } else {
            if (currentGroup) groupedEmails.push(currentGroup);
            currentGroup = {
              ...email,
              recipients: [email.receiver_email],
              isGrouped: true,
              id: email.id
            };
          }
        } else {
          if (currentGroup) {
            groupedEmails.push(currentGroup);
            currentGroup = null;
          }
          groupedEmails.push({
            ...email,
            isGrouped: false
          });
        }
      });
  
      if (currentGroup) groupedEmails.push(currentGroup);
  
      setGroupedEmailHistory(groupedEmails);
    } catch (error) {
      console.error("Error fetching email history:", error);
    }
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [groupedEmailHistory]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      alert("File size must be below 2MB.");
      return;
    }
    setSelectedFile(file);
  };

   const handleSendEmail = async () => {
    if (!text && !selectedFile) {
      alert("Please enter a message or upload a file.");
      return;
    }

    if (!userEmail) {
      alert("Sender email not found. Please log in again.");
      return;
    }

    const receivers = receiverEmails.split(",").map(email => email.trim()).filter(Boolean);
    if (receivers.length === 0) {
      alert("Please enter at least one recipient email.");
      return;
    }

    const cc = showCC ? ccEmails.split(",").map(email => email.trim()).filter(Boolean) : [];
    const bcc = showBCC ? bccEmails.split(",").map(email => email.trim()).filter(Boolean) : [];

    setLoading(true);
    const formData = new FormData();
    formData.append("leadid", leadid);
    
      formData.append("sender_email", userEmail);
   
    formData.append("text", text);
    formData.append("subject", subject || "New Message");
    formData.append("type", "sent");
    formData.append("is_plain_text", "false");
    formData.append("receiver_emails", JSON.stringify(receivers));
    if (showCC) formData.append("cc_emails", JSON.stringify(cc));
    if (showBCC) formData.append("bcc_emails", JSON.stringify(bcc));

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    try {
      await axios.post(`${baseURL}/api/send-bulk-emails`, formData);
      alert("Emails sent successfully!");
      setText("");
      setSubject("");
     // setReceiverEmails("");
      setCcEmails("");
      setBccEmails("");
      setSelectedFile(null);
      fetchEmailHistory(leadid);
    } catch (error) {
      console.error("Error sending bulk emails:", error);
      alert("Failed to send bulk emails.");
    }

    setLoading(false);
  };


  const cleanEmailText = (text) => {
    if (!text) return "";
    const cleanedText = text.split(/\n?On\s.+\s(?:at|wrote:)/i)[0];
    return cleanedText.replace(/--\sThis email has been checked for viruses.*/is, "").trim();
  };
  return (
    <div className="email-container">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`chat-content ${collapsed ? "collapsed" : ""}`}>
        <Tabs
          defaultActiveKey="emails"
          onSelect={(key) => {
            if (key === 'comments') navigate(`/m-myopportunity-comments/${leadid}`);
          }}
          className="mb-3"
        >
          <Tab eventKey="comments" title="Comments" />
          <Tab eventKey="emails" title="Email History">
         
          </Tab>
        </Tabs>
        <h2 className="email-header">Email History with <span>{email}</span></h2>
                        
                        <div className="email-history-list">
                          {groupedEmailHistory.map((emailItem) => (
                            <div 
                              key={`${emailItem.id}_${emailItem.created_at}`} 
                              className="email-history-item"
                              style={{
                                display: "flex",
                                justifyContent: emailItem.type === "sent" ? "flex-end" : "flex-start",
                                width: "100%"
                              }}
                            >
                              <div 
                                className={`opp-message-bubble ${emailItem.type === "sent" ? "sent" : "received"}`}
                                style={{
                                  maxWidth: "80%",
                                  padding: "10px 15px",
                                  borderRadius: emailItem.type === "sent" ? "18px 18px 0 18px" : "18px 18px 18px 0",
                                  backgroundColor: emailItem.type === "sent" ? "#DCF8C6" : "#FFFFFF",
                                  boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
                                  border: "1px solid #eee",
                                  marginBottom: "10px"
                                }}
                              >
                                {emailItem.isGrouped && (
                                  <div className="recipients">
                                    <strong>Recipients:</strong> <b>{emailItem.recipients.join(", ")}</b>
                                  </div>
                                )}
                                <p className="email-subject">
                                  <strong>Subject:</strong> {emailItem.subject || "No Subject"}
                                </p>
                                {!emailItem.isGrouped && emailItem.type === "sent" && (
                                  <p className="email-receivers">
                                    <strong>To:</strong> {emailItem.receiver_email}
                                  </p>
                                  
                                )}
                                
                                
                                {!emailItem.isGrouped && emailItem.type === "received" && (
                                  <p className="email-receivers">
                                    <strong>From:</strong> {emailItem.sender_email}
                                  </p>
                                )}
                                {emailItem.cc && (
                                  <p className="email-cc">
                                    <strong>CC:</strong> {emailItem.cc}
                                  </p>
                                )}
                                <div
                                  className="email-content"
                                  dangerouslySetInnerHTML={{ __html: cleanEmailText(emailItem.text) }}
                                />
                                {emailItem.file_path && (
                                  <a 
                                    href={`${baseURL}${emailItem.file_path}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="attachment-link"
                                    style={{
                                      display: "inline-block",
                                      marginTop: "5px",
                                      color: "#007bff",
                                      textDecoration: "none"
                                    }}
                                  >
                                    📎 View Attachment
                                  </a>
                                )}
                                <div 
                                  className="timestamp" 
                                  style={{
                                    fontSize: "0.75rem",
                                    color: "#666",
                                    textAlign: emailItem.type === "sent" ? "right" : "left",
                                    marginTop: "5px"
                                  }}
                                >
                                  {new Date(emailItem.created_at).toLocaleString()}
                                </div>
                              </div>
                            </div>
                          ))}
                          <div ref={chatEndRef} />
                        </div>
                
                       <div className="email-form">
                          <h3>Send Email</h3>
                          <div className="form-group">
                            <label>To:</label>
                            <textarea
                              placeholder="Enter recipient emails (comma separated)"
                              value={receiverEmails}
                              onChange={(e) => setReceiverEmails(e.target.value)}
                              className="input-receivers"
                            />
                          </div>
                
                          <div className="cc-bcc-toggle">
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                checked={showCC}
                                onChange={() => setShowCC(!showCC)}
                              />
                              Add CC
                            </label>
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                checked={showBCC}
                                onChange={() => setShowBCC(!showBCC)}
                              />
                              Add BCC
                            </label>
                          </div>
                
                          {showCC && (
                            <div className="form-group">
                              <label>CC:</label>
                              <textarea
                                placeholder="Enter CC emails (comma separated)"
                                value={ccEmails}
                                onChange={(e) => setCcEmails(e.target.value)}
                                className="input-receivers"
                              />
                            </div>
                          )}
                
                          {showBCC && (
                            <div className="form-group">
                              <label>BCC:</label>
                              <textarea
                                placeholder="Enter BCC emails (comma separated)"
                                value={bccEmails}
                                onChange={(e) => setBccEmails(e.target.value)}
                                className="input-receivers"
                              />
                            </div>
                          )}
                
                          <div className="form-group">
                            <label>Subject:</label>
                            <input
                              type="text"
                              placeholder="Enter Subject"
                              value={subject}
                              onChange={(e) => setSubject(e.target.value)}
                              className="input-subject"
                            />
                          </div>
                          <div className="form-group">
                            <label>Message:</label>
                            <ReactQuill
                              theme="snow"
                              value={text}
                              onChange={setText}
                              className="rich-text-editor"
                              placeholder="Enter your message here..."
                            />
                          </div>
                          <div className="form-group">
                            <label>Attachment:</label>
                            <input 
                              type="file" 
                              onChange={handleFileChange} 
                              className="file-input mb-2"
                            />
                          </div>
                          <button 
                            onClick={handleSendEmail} 
                            disabled={loading} 
                            className="send-button"
                          >
                            {loading ? "Sending..." : "Send Email"}
                          </button>
                        </div>
        
      </div>
    </div>
  );
};

export default M_MyEmailHistory;
